/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const INT_CART_API_URL = `${process.env.API}/cart/internal`;
export const INT_SHIFT_API_URL = `${process.env.API}/shift`;
export const INT_ACCOUNT_API_URL = `${process.env.API}/accounts/internal`;
export const TIMED_ENTRY_API_URL = `${process.env.API}/timedentry/internal`;
export const TICKET_API_URL = `${process.env.API}/ticket/internal`;
export const TOKEN_LOCAL_STORAGE_KEY = 'internalaccount';

export const INYO_NF_PERMIT_ID = '233262';
export const BOUNDARY_WATERS_PERMIT_ID = '233396';
export const LOWER_DESCHUTES_PERMIT_ID = '251980';

export const PERSIST_KEY = 'fieldsales';

export const FEE_TYPE_ADJUSTMENT = 'ADJUSTMENT';
export const FEE_TYPE_DISCOUNT = 'PERCENT_DISCOUNT';

export const FEE_TYPE_LABELS = {
    ADJUSTMENT: 'Adjustment',
    PERCENT_DISCOUNT: 'Discount',
};

export const DATE_FORMAT_MONTH_DAY_YEAR_ABBR = 'MM/DD/YY';
export const TIME_FORMAT_HOUR_MINUTE_PERIOD = 'hh:mm A';

// payment types
export const PAYMENT_TYPE_CARD = 'CARD';
export const PAYMENT_TYPE_PAPER = 'PAPER';
export const PAYMENT_TYPE_DIGITAL_WALLET = 'PRS_WALLET';

// inventory types
export const INVENTORY_CAMPING = 'CAMPING';
export const INVENTORY_TICKET = 'TICKET';
export const INVENTORY_TIMED_ENTRY = 'TIMED_ENTRY';
